import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";

export const GetUserConsentsBIZidentity = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getUserConsentsBIZidentity(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_USER_CONSENTS_BIZ_IDENTITY, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
